import { lazy } from 'react';

/** Открывает экран планировщика */
export const CronJobFormPageAsync = lazy(() => import('./CronJobForm/CronJobFormPage'));
